import React from 'react'
import { IAuditEventData, LicensedAgencyAuditSnapshotV1 } from '../../../api'
import { useDetailStyles } from './useDetailStyles'
import { Box } from 'cs-kevlar-react'
import { UnavailableDetails } from './UnavailableDetails'
import { resolveSnapshots } from './utils'
import { DetailField } from './DetailField'

interface CustomerLicensedAgencyDetailsProps {
  eventData: IAuditEventData
}

export const CustomerLicensedAgencyDetails: React.FunctionComponent<CustomerLicensedAgencyDetailsProps> = ({
  eventData,
}) => {
  const classes = useDetailStyles()
  const [originalSnapshot, updatedSnapshot] = resolveSnapshots<
    LicensedAgencyAuditSnapshotV1
  >(eventData, nameof<LicensedAgencyAuditSnapshotV1>())
  const showDiff = !!originalSnapshot && !!updatedSnapshot

  if (!updatedSnapshot && !originalSnapshot) return <UnavailableDetails />

  return (
    <React.Fragment>
      <Box className={classes.fieldsContainer}>
        <DetailField
          label="Name"
          showDiff={showDiff}
          original={originalSnapshot?.name}
          updated={updatedSnapshot?.name}
        />

        <DetailField
          label="Agency ID"
          showDiff={showDiff}
          original={originalSnapshot?.uniqueIdentifier}
          updated={updatedSnapshot?.uniqueIdentifier}
        />

        <DetailField
          label="Licenses"
          showDiff={showDiff}
          original={originalSnapshot?.licenseCount?.toString()}
          updated={updatedSnapshot?.licenseCount?.toString()}
        />

        <DetailField
          label="Authentication Type"
          showDiff={showDiff}
          original={originalSnapshot?.authenticationType}
          updated={updatedSnapshot?.authenticationType}
        />

        <DetailField
          label="Notes"
          showDiff={showDiff}
          original={originalSnapshot?.notes}
          updated={updatedSnapshot?.notes}
        />
      </Box>
    </React.Fragment>
  )
}
